var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableDefaultNotFoundIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1133 26.75C27.3479 29.8421 24.0606 31.7506 20.5 31.7506C16.9394 31.7506 13.6521 29.8421 11.8867 26.75H5.5C4.11929 26.75 3 27.8693 3 29.25V36.75C3 38.1307 4.11929 39.25 5.5 39.25H35.5C36.8807 39.25 38 38.1307 38 36.75V29.25C38 27.8693 36.8807 26.75 35.5 26.75H29.1133Z",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21.75V4.25C33 2.86929 31.8807 1.75 30.5 1.75H10.5C9.11929 1.75 8 2.86929 8 4.25V21.75",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4042 18.5729C18.1362 19.5357 19.2924 20.0802 20.5008 20.0312C22.3992 20.0312 23.9375 18.8779 23.9375 17.4529C23.9375 16.0279 22.3992 14.8762 20.5008 14.8762C18.6025 14.8762 17.0625 13.7212 17.0625 12.2962C17.0625 10.8712 18.6025 9.71789 20.5008 9.71789C21.7093 9.66891 22.8655 10.2134 23.5975 11.1762",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20.0312V21.7496",
    stroke: "#B0E577",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8V9.71833",
    stroke: "#B0E577",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDefaultNotFoundIcon);
export default __webpack_public_path__ + "static/media/table-default-not-found-icon.12873fc4b21380ccb6ce86263a4d427d.svg";
export { ForwardRef as ReactComponent };